import { Row, Typography } from 'antd';
import { FormattedMessage } from 'react-intl';

import { useSectionHeaderStyles } from './SectionHeader.styles';

export default function SectionHeader({ title }) {
  const { styles } = useSectionHeaderStyles();
  return (
    <Row className={styles.quoteHeader} align="middle" justify="space-between">
      <Typography.Title level={4}>
        <FormattedMessage id={title} />
      </Typography.Title>
    </Row>
  );
}
